import type { RouteDataFuncArgs } from "@solidjs/router";
import { queryOptions } from "@tanstack/solid-query";
import { axiosClient } from "~/js/network/axiosClient";
import type { AuthRouterContext } from "~/solidJs/app/MainApp/models";
import { getUserStore } from "~/solidJs/entities/HeaderMain/models";
import { AirtableProxiApi } from "~/solidJs/shared/api/AirtableProxyApi";
import { BaseApi } from "~/solidJs/shared/api/baseApi";
import { queryClient } from "~/solidJs/shared/api/queryClient";
import type {
	INodeDefinition,
	NodeVisibility
} from "~/solidJs/shared/helpers/types/INodeDefinition";
import { registratePaymentsInAnalitycs } from "~/solidJs/shared/helpers/userHelpers";

interface Node {
	nodeDefinition: INodeDefinition;
}

interface NodeWrapper {
	node: Node;
	isAvailable: boolean;
	isVisible: NodeVisibility;
	default_price: number;
}

export class IndexApi extends BaseApi {
	static getFetchCloundNodeListOptions() {
		return queryOptions({
			queryKey: [IndexApi.fetchCloudNodeListKey, getUserStore()?.group],
			queryFn: () => IndexApi.fetchCloudNodeList(),
			gcTime: Number.POSITIVE_INFINITY
		});
	}
	static fetchCloudNodeListKey = "fetchCloudNodeListKey";

	/**
	 * fetches node definitions from backend
	 */
	static async fetchCloudNodeList() {
		try {
			const response = await axiosClient.axiosClient.get<NodeWrapper[]>("api/v2/nodes/");
			const responseJson = response.data;
			if (response.status === 401) return [];
			const models = responseJson.map((item) => {
				item.node.nodeDefinition.isVisible = item.isVisible;
				item.node.nodeDefinition.isAvailable = item.isAvailable;
				item.node.nodeDefinition.defaultPrice = item.default_price;
				return item.node.nodeDefinition;
			});
			return models;
		} catch (error) {
			console.error("[NODE STORAGE] Failed to get node models from remote storage.", error);
			throw new Error(error instanceof Error ? error.message : String(error));
		}
	}
	static prefetchIndexData() {
		queryClient.prefetchQuery(IndexApi.getFetchCloundNodeListOptions());

		// queryClient.prefetchQuery({
		// 	queryKey: [HomePageApi.airtableTemplatesQueryKey],
		// 	queryFn: HomePageApi.getAirtableTemplates.bind(HomePageApi)
		// });
		// queryClient.prefetchQuery({
		// 	queryKey: [HomePageApi.airtableTasksQueryKey],
		// 	queryFn: HomePageApi.getAirtableTasks.bind(HomePageApi)
		// });
		queryClient.prefetchQuery(AirtableProxiApi.getfetchAndTransformMlBaseQueryOptions());
		// queryClient.prefetchInfiniteQuery({
		// 	queryKey: [AirtableProxiApi.onboardingFeedKey],
		// 	queryFn: (props) =>
		// 		AirtableProxiApi.fetchTransformOnboarding(
		// 			props.pageParam.limit,
		// 			props.pageParam.offset
		// 		),
		// 	initialPageParam: { limit: 10, offset: 0 },
		// 	getNextPageParam: (lastPage) => ({
		// 		offset: lastPage.offset,
		// 		limit: 10
		// 	}),
		// 	pages: 1
		// });
	}
	static async loadIndexData(props: RouteDataFuncArgs<AuthRouterContext>) {
		const user = await props.data.user;
		if (!user) {
			return;
		}
		IndexApi.prefetchIndexData();
		registratePaymentsInAnalitycs();
		return props.data;
	}
}
